module.exports = __webpack_public_path__ + "static/media/hogwarts.3c07a64c.png";